import { Button, Modal } from "react-bootstrap"
import { iReqMetrics } from "./TablePesquisaRegistros"

export default function ModalViewReqDados({ dados, show, handleClose }:iProps) {

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title><b>{dados.method}, Status Code {dados.statusCode}: {dados.url}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ textAlign: "justify" }}>
                <p>Origem: API-{dados.api} {dados.origem}</p>
                <p>Data: {dados.data_criacao}</p>
                <p>Usuario: {dados.user}</p>
                <p>Timestamp: {dados.timestamp}</p>
                <p>Dia: {dados.data_dia}</p>
                <p>Response Time: {dados.responseTime}</p>
                <p>Req / Res Size: {dados.reqSize} / {dados.resSize}</p>
                <p>realIp: {dados.realIp}</p>
                <p>Agente: {dados.userAgent}</p>
                <p>Payload:</p>
                <pre><code id="jsonText"></code></pre>
                { dados.payload === null || dados.payload === "" ? "" : <div className="payload">{dados.payload}</div> }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}
interface iProps {
    show: boolean
    handleClose: any
    dados: iReqMetrics
}